import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { JwtModule, JwtInterceptor } from '@auth0/angular-jwt';

import { ApiTranslateLoader } from './shared/apiTranslationLoader';
import { ApiMissingTranslationHandler } from './shared/apiMissingTranslationHandler';

import { httpInterceptorProviders } from './shared/http-interceptors';
import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { MainModule } from './main/main.module';
import { CitizenModule } from './citizen/citizen.module';
import { HelpModule } from './help/help.module';

import { AppComponent } from './app.component';
import { ErrorComponent } from './error/error.component';


export function tokenGetter(): string {
    return localStorage.getItem(environment.tokenKey);
}

// AoT requires an exported function for factories
export function ApiLoaderFactory(http: HttpClient): ApiTranslateLoader {
    return new ApiTranslateLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        ErrorComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        HttpClientModule,
        AppRoutingModule,
        SharedModule,
        MainModule,
        CitizenModule,
        HelpModule,
        FontAwesomeModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
                whitelistedDomains: [environment.apiDomain],
                blacklistedRoutes: [environment.identityApiUrl + 'connect/token']
            }
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: ApiLoaderFactory,
                deps: [HttpClient]
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: ApiMissingTranslationHandler
            }
        })
    ],
    providers: [
        httpInterceptorProviders,
        JwtInterceptor
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
